const Win = () => {
  return <h1>{'Congratulations!!!'}</h1>;
};

export {Win};
